import { render, staticRenderFns } from "./LoyaltyDropDown.vue?vue&type=template&id=08aef8c3&lang=pug&"
import script from "./LoyaltyDropDown.vue?vue&type=script&lang=js&"
export * from "./LoyaltyDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports